export const KILOMETERS_IN_MILE = 1.60934;
export const SPEED_FORMATS = ['mph', 'kph'] as const;
